import SidebarLayout from "@/components/feature/SidebarLayout";
import HeroSection from "./components/HeroSection";
import MessageSection from "./components/MessageSection";
import MissionSection from "./components/MissionSection";
import ServiceSection from "./components/ServiceSection";
import NewsSection from "./components/NewsSection";
import SNSFeedSection from "./components/SNSFeedSection";
import ContactCTA from "./components/ContactCTA";

export default function Home() {
  return (
    <SidebarLayout showBreadcrumb={false} showContactButton={false} showTopBar={false}>
      <HeroSection />
      <MessageSection />
      <MissionSection />
      <ServiceSection />
      <NewsSection />
      <SNSFeedSection />
      <ContactCTA />
    </SidebarLayout>
  );
}